<script lang="ts" setup>
import logo from '@/assets/paypal.png'
</script>
<template>
    <img :src="logo" alt="Logo Paypal" width="32" height="32" />
</template>
